// components/DashboardPreview/DashboardPreview.jsx
import React, { useState } from "react";
import PreviewNavbar from "./PreviewNavbar";
import PreviewSidebar from "./PreviewSidebar";
import PreviewTabs from "./PreviewTabs";
import PreviewKPIGrid from "./PreviewKPIGrid";

import "./dashboardPreview.css";

const DashboardPreview = ({ payload, onClose }) => {
  const { meta, layout, tabs, globalFilters, selectedTabId, theme } = payload;

  const [activeTabId, setActiveTabId] = useState(
    selectedTabId || tabs?.[0]?.id
  );

  const activeTab = tabs.find((t) => t.id === activeTabId);

  // Default theme if not provided
  const defaultTheme = {
    navbar: {
      background: "#ffffff",
      textColor: "#333333",
      borderColor: "#e0e0e0",
    },
    sidebar: {
      background: "#ffffff",
      textColor: "#333333",
      borderColor: "#e0e0e0",
      labelColor: "#555555",
      inputBackground: "#f9f9f9",
      inputBorderColor: "#d0d0d0",
    },
    tabs: {
      background: "#ffffff",
      textColor: "#333333",
      activeBackground: "#2563eb",
      activeTextColor: "#ffffff",
      borderColor: "#d0d0d0",
      hoverBackground: "#f0f0f0",
    },
    kpiCard: {
      background: "#ffffff",
      textColor: "#333333",
      titleColor: "#333333",
      borderColor: "transparent",
      shadow: "0 2px 8px rgba(0,0,0,0.08)",
    },
    chart: {
      background: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
      textColor: "#4f46e5",
      colors: ["#2563eb", "#7c3aed", "#db2777", "#ea580c", "#16a34a", "#0891b2", "#6366f1"],
    },
    table: {
      headerBackground: "#f3f4f6",
      headerTextColor: "#111827",
      rowBackground: "#ffffff",
      rowHoverBackground: "#f9fafb",
      borderColor: "#e5e7eb",
      textColor: "#374151",
    },
    mainBackground: "#f5f7fa",
  };

  const appliedTheme = { ...defaultTheme, ...theme };

  return (
    <div className="preview-overlay">
      <div 
        className="preview-container"
        style={{ background: appliedTheme.mainBackground }}
      >
        {layout?.topNavbar && (
          <PreviewNavbar 
            logo={meta.logo} 
            title={meta.title || "Dashboard Preview"}
            theme={appliedTheme.navbar}
          />
        )}

        <div className="preview-body">
          {layout?.sidebar && (
            <PreviewSidebar 
              filters={globalFilters} 
              tabs={tabs}
              selectedTabId={activeTabId}
              theme={appliedTheme.sidebar}
            />
          )}

          <div 
            className="preview-main"
            style={{ background: appliedTheme.mainBackground }}
          >
            <PreviewTabs
              tabs={tabs}
              view={meta.tabView}
              activeTabId={activeTabId}
              setActiveTabId={setActiveTabId}
              theme={appliedTheme.tabs}
            />

            <PreviewKPIGrid 
              tab={activeTab}
              cardTheme={appliedTheme.kpiCard}
              chartTheme={appliedTheme.chart}
              tableTheme={appliedTheme.table}
            />
          </div>
        </div>

        <button className="preview-close-btn" onClick={onClose}>
          ✖ Close
        </button>
      </div>
    </div>
  );
};

export default DashboardPreview;